<template>
  <v-snackbar
    v-model="alertStore.show"
    :multi-line="multiLine"
    :timeout="3000"
    :color="alertStore.colour"
    rounded="lg"
    elevation="24"
    :location="alertStore.pos"
  >
    {{ alertStore.message }}
  </v-snackbar>
</template>

<script setup>
  import { useAlertStore } from "@/store/alert";
  import { computed } from "vue";
  const alertStore = useAlertStore();
  const multiLine = computed(() => {
    return alertStore.message.length > 50;
  });
</script>
